import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SpecraButton } from '@mono/ui-components';
import { ArrowLeft, Loader2, MessageSquare } from 'lucide-react';
import { useProjectContext } from '../../../contexts/ProjectContext';
import { formatRelativeTime } from '../../../utils/time';
import { useProjectConversations } from './hooks/useProjectConversations';
/**
 * Slide-over panel inside the AI sidebar showing project-scoped chat history.
 * Fetches from express-backend which merges MongoDB + shanks conversations.
 */ export function SidebarChatHistory({ onBack, onSelectChat }) {
    const { projectId } = useProjectContext();
    const { data: chats, isLoading, isError, refetch } = useProjectConversations(projectId);
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex h-full flex-col",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "flex items-center gap-2 border-b border-slate-200 px-4 py-3",
                children: [
                    /*#__PURE__*/ _jsx("button", {
                        type: "button",
                        onClick: onBack,
                        className: "rounded p-1 text-slate-400 hover:bg-slate-100 hover:text-slate-700",
                        "aria-label": "Back to chat",
                        children: /*#__PURE__*/ _jsx(ArrowLeft, {
                            className: "h-4 w-4"
                        })
                    }),
                    /*#__PURE__*/ _jsx("span", {
                        className: "text-sm font-medium text-slate-900",
                        children: "Chat History"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "flex-1 overflow-y-auto",
                children: isLoading ? /*#__PURE__*/ _jsx("div", {
                    className: "flex items-center justify-center py-12",
                    children: /*#__PURE__*/ _jsx(Loader2, {
                        className: "h-5 w-5 animate-spin text-slate-400"
                    })
                }) : isError ? /*#__PURE__*/ _jsxs("div", {
                    role: "alert",
                    className: "p-4 text-sm",
                    children: [
                        /*#__PURE__*/ _jsx("p", {
                            children: "Your conversation list could not load."
                        }),
                        /*#__PURE__*/ _jsx(SpecraButton, {
                            variant: "secondary",
                            onClick: ()=>void refetch(),
                            children: "Retry loading conversations"
                        })
                    ]
                }) : !chats || chats.length === 0 ? /*#__PURE__*/ _jsxs("div", {
                    className: "px-4 py-12 text-center",
                    children: [
                        /*#__PURE__*/ _jsx(MessageSquare, {
                            className: "mx-auto h-6 w-6 text-slate-300"
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "mt-2 text-xs text-slate-500",
                            children: "No conversations yet"
                        })
                    ]
                }) : /*#__PURE__*/ _jsx("ul", {
                    className: "divide-y divide-slate-100",
                    children: chats.map((chat)=>/*#__PURE__*/ _jsx("li", {
                            children: /*#__PURE__*/ _jsx("button", {
                                type: "button",
                                onClick: ()=>onSelectChat(chat.chatId),
                                className: "w-full px-4 py-3 text-left hover:bg-slate-50 transition-colors",
                                children: /*#__PURE__*/ _jsxs("div", {
                                    className: "flex items-center justify-between gap-2",
                                    children: [
                                        /*#__PURE__*/ _jsx("span", {
                                            className: "truncate text-sm font-medium text-slate-800",
                                            children: chat.title
                                        }),
                                        /*#__PURE__*/ _jsx("span", {
                                            className: "flex-shrink-0 text-[10px] text-slate-400",
                                            children: formatRelativeTime(chat.updatedAt || chat.createdAt)
                                        })
                                    ]
                                })
                            })
                        }, chat.chatId))
                })
            })
        ]
    });
}
